import { render, staticRenderFns } from "./ProjectAuditTrailHistory.vue?vue&type=template&id=003230ed"
import script from "./ProjectAuditTrailHistory.vue?vue&type=script&lang=js"
export * from "./ProjectAuditTrailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports